<template>
        <div class="table-filters">
          <div class="name" v-if="modelValue && modelValue.length">Applied filters:</div>
          <ul class="applied">
            <li class="none" v-if="false && (!modelValue || !modelValue.length)">
              (none)
            </li>
            <li v-for="(filter, fi) of modelValue || []">
              <span>{{ filter.title }}</span>
              <a href="" @click.prevent="removeFilter(fi)"><i class="fa-solid fa-xmark"></i></a>
            </li>
          </ul>
          <a href="" class="btn btn-danger" @click.prevent="removeAll" v-if="modelValue && modelValue.length">Clear all</a>
          <a href="" class="btn btn-primary" @click.prevent="">Filters</a>
        </div>
</template>
<script>
export default {
  props: ["modelValue"],
  methods: {
    removeFilter(index) {
      var result=(this.modelValue || []).slice();
      result.splice(index, 1);
      this.$emit("update:modelValue", result);
    },
    removeAll() {
      this.$emit("update:modelValue", []);
    },
  },

}
</script>
